// src/components/Navbar.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../css/navbar.css";
import logo from "../images/lovelycakeslogo.jpeg";

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
  const closeMenu = () => setIsMobileMenuOpen(false);

  return (
    <nav className="luxe-navbar">
      <div className="nav-container">
        <div className={`nav-left ${isMobileMenuOpen ? "active" : ""}`}>
          <Link to="/cakes" className="nav-link" onClick={closeMenu}>
            Cakes
          </Link>
          <Link to="/aboutus" className="nav-link" onClick={closeMenu}>
            About Us
          </Link>
          <Link to="/contact" className="nav-link" onClick={closeMenu}>
            Contact Us
          </Link>
        </div>

        <div className="nav-center">
          <Link to="/" className="brand-logo" onClick={closeMenu}>
            <img src={logo} alt="Lovely Cakes Logo" className="logo-image" />
          </Link>
        </div>

        <button
          className={`hamburger ${isMobileMenuOpen ? "open" : ""}`}
          onClick={toggleMenu}
          aria-label="Menu"
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
